<template>
    <svg :width="size" :height="size" viewBox="0 0 56 56" class="sod-eod-progress-ring">
        <circle cx="28" cy="28" r="22" fill="none" stroke="rgba(0,0,0,0.08)" :stroke-width="strokeWidth" />
        <circle cx="28" cy="28" r="22" fill="none" :stroke="color" :stroke-width="strokeWidth"
            stroke-linecap="round" :stroke-dasharray="circumference"
            :stroke-dashoffset="offset" transform="rotate(-90 28 28)" />
        <text x="28" y="32" text-anchor="middle" class="sod-eod-progress-ring-text" :fill="color">
            {{ Math.round(clampedPercent) }}%
        </text>
    </svg>
</template>

<script>
export default {
    name: 'SodEodProgressRing',
    props: {
        percent: {
            type: Number,
            default: 0,
        },
        color: {
            type: String,
            default: '#2f6fed',
        },
        size: {
            type: Number,
            default: 52,
        },
        strokeWidth: {
            type: Number,
            default: 5,
        },
    },
    computed: {
        clampedPercent() {
            return Math.max(0, Math.min(100, this.percent || 0));
        },
        circumference() {
            return 2 * Math.PI * 22;
        },
        offset() {
            return this.circumference * (1 - this.clampedPercent / 100);
        },
    },
};
</script>

<style scoped>
.sod-eod-progress-ring circle:nth-child(2) {
    transition: stroke-dashoffset 0.4s ease;
}

.sod-eod-progress-ring-text {
    font-size: 12px;
    font-weight: 700;
}
</style>
